import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const postCreateTicketOutbound = createApi(`CreateTicketOutbountSlice`,"POST");

const CreateTicketOutbountSlice = createSlice({
  name: 'CreateTicketOutbountSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postCreateTicketOutbound.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postCreateTicketOutbound.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postCreateTicketOutbound.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default CreateTicketOutbountSlice.reducer;